import React from 'react';
import uid from 'utils/uid';
import { Checkbox } from 'elements';
import { ArrowDropDown } from 'core/icons';
import isDescendant from 'utils/isDescendant';
import {
  StyledFilterSelect,
  ListDrop,
  StyledFilterItem,
} from './styled';

class FilterSelect extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      selectedOption: null,
    };
  }

  // TODO: FilterSelect, ThemeModeMenu un
  // FontSizeMenu pārstrāde ar vienotu pieeju.

  componentDidMount() {
    if (window) {
      this._uid = uid();
      window.addEventListener('click', this._onWindowClick);
    }
  }

  _onSelectClick = () => {
    this.setState(prevState => Object.assign({}, prevState, {
      open: !prevState.open,
    }), () => {
      if (this.state.open) {
        // NOTE: Novietojam fokusu uz izvēlēto elementu uzreiz pēc menu atvēršanas
        const selectedOption = this._drop.querySelector('li[aria-selected="true"]');
        if (selectedOption) {
          selectedOption.focus();
        }
      }
    });
  }

  _onWindowClick = (event) => {
    const inside = isDescendant(this._select, event.target);
    if (!inside) {
      this.setState(prevState => Object.assign({}, prevState, {
        open: false,
      }));
    }
  }

  render() {
    const {
      defaultOption,
      onChange,
      options,
      multiple,
    } = this.props;

    const allOptions = [defaultOption, ...options];
    const selectedOptions = allOptions.filter(filter => filter.selected);

    const filterOptions = allOptions
      .filter(filter => !filter.hasOwnProperty('count') || filter.count > 0)
      .map((filter, i) => {
      const globalId = `${this._uid}-${i + 1}`;
      return (
        <StyledFilterItem
          key={i}
          role='option'
          aria-selected={filter.selected}
        >
          <Checkbox
            id={globalId}
            checked={filter.selected}
            onChange={() => {
              onChange && onChange(filter.id, !filter.selected)
            }}
          />
          <label htmlFor={globalId}>
              {filter.label}
          </label>
        </StyledFilterItem>
      );
    });

    /* NOTE: Izmantojams, ja der mazie burti visās situācijās.
    const [firstCharOfLabel, ...restOfLabel] = selectedOptions.map(filter => (
      filter.label.toLowerCase()
    )).join(', ');
    const filterLabel = firstCharOfLabel.toUpperCase() + restOfLabel.join(''); */

    const filterLabel = selectedOptions.map(filter => filter.label).join(', ');

    return (
      <StyledFilterSelect
        role='listbox'
        aria-expanded={this.state.open}
        aria-activedescendant={this.state.selectedOption}
        innerRef={c => this._select = c}
      >
        <button
          id={this._uid}
          type="button"
          onClick={this._onSelectClick}
        >
          <span>
            {filterLabel}
          </span>
          <ArrowDropDown />
        </button>

        <ListDrop
          innerRef={c => this._drop = c}
          open={this.state.open}
        >
          {filterOptions}
        </ListDrop>
      </StyledFilterSelect>
    );
  }
}

export default FilterSelect;



// WEBPACK FOOTER //
// ./src/pages/Rezultati/components/FilterSelect/FilterSelect.jsx